package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.logic.NavigatorBagPage
import com.example.mystybag.common.logic.BSNavigationFilterResults
import com.example.mystybag.commonData.helpers.PlatformDefines.ANDROID
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_IS_PRIVATE_MODE
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_PHOTO_GUID
import com.example.mystybag.core.expected.Preferences.getBoolean
import com.example.mystybag.core.expected.Preferences.getString
import com.example.mystybag.commonData.expected.getOS
import com.example.mystybag.core.expected.getCurrentUserLocation
import com.example.mystybag.core.expected.isNFCChipPresent
import com.example.mystybag.communication.login.LoginCommands
import com.example.mystybag.sharedmodels.project.responseModels.CityResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.GetCitiesResponseModel
import com.example.mystybag.core.extensions.addDownloadLink
import com.example.mystybag.core.extensions.ifNotEmpty
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.permissionsUtils.expected.Permission
import com.example.mystybag.permissionsUtils.expected.PermissionHelper
import com.example.mystybag.core.logic.base.AppViewModel.Companion.navigateTo
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.FeatureManagers
import com.example.mystybag.core.logic.base.ScrollToTopInterface
import com.example.mystybag.core.model.ButtonImageVisualModel
import com.example.mystybag.core.model.HeaderRowVisualModel
import com.example.mystybag.core.model.IconDescription
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.common.expected.hideWebHomeMapOverlayNow
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme.p18
import com.example.mystybag.appCore.model.pages.FilterResultsUIState
import com.example.mystybag.appCore.model.pages.HomePageUIState
import com.example.mystybag.appCore.model.pages.HomeViewMode
import com.example.mystybag.appCore.model.pages.BusinessCategory
import com.example.mystybag.sharedmodels.project.responseModels.calculateDistanceMeters
import com.example.mystybag.sharedmodels.project.responseModels.formatDistance
import com.example.mystybag.communication.common.CommonCommands.addFavoriteCommand
import com.example.mystybag.communication.common.CommonCommands.getMerchantEmbeddings
import com.example.mystybag.sharedmodels.project.responseModels.BagCategoryLists
import com.example.mystybag.sharedmodels.project.responseModels.BagWithTextsAndMeta
import com.example.mystybag.communication.common.CommonCommands.removeFavoriteCommand
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_USER_ID
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.helpers.GlobalCommonData
import com.example.mystybag.database.communication.db.DatabaseProvider
import com.example.mystybag.e5AiSearch.helpers.E5Runtime
import com.example.mystybag.e5AiSearch.helpers.SearchRankingRuntime
import com.example.mystybag.e5AiSearch.helpers.categoryKeywordsRaw
import com.example.mystybag.e5AiSearch.helpers.normalizeQueryForSearch
import com.example.mystybag.e5AiSearch.helpers.searchLocalTwoStage
import com.example.mystybag.e5AiSearch.helpers.setCategoryKeywords
import com.example.mystybag.sharedmodels.project.requestModels.favorites.AddFavoriteRequestModel
import com.example.mystybag.sharedmodels.project.requestModels.favorites.RemoveFavoriteRequestModel
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel
import com.example.mystybag.sharedmodels.project.responseModels.nomenclatures.GetSearchRankingConfigResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.toHomeTopPickUiModel
import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.channels.BufferOverflow
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.withContext
interface HomePageCallbacks {
    fun handleBannerClick(type: String)
    fun refreshBags(onComplete: (() -> Unit)? = null)
    fun removeFavorite(item: HomeTopPickUiModel)
}

class HomePageViewModel(
    context: AppContext
) : ChildViewModel<HomePageUIState>(context, HomePageUIState()), ScrollToTopInterface {
    private var isNavigatingToBag = false
    
    companion object {
        // Business category IDs (must match server nomenclature)
        private const val CATEGORY_ID_BAKERY = 1L
        private const val CATEGORY_ID_CONFECTIONERY = 2L
        private const val CATEGORY_ID_FOOD_FOR_HOME = 3L
        private const val CATEGORY_ID_FISH_MARKET = 4L
    }
    
    val scrollToTopChannel = Channel<Unit>(
        capacity = 1,
        onBufferOverflow = BufferOverflow.DROP_OLDEST
    )

    override fun onCreate() {
        navCallbacks.controls.value.backButtonVisible   = false
        loadInitialData()
    }

    override fun onResume() {
        isNavigatingToBag = false
    }

    private fun loadInitialData() {
        getEmbeddings()
        observeSearch()
        updateHeader()
        fetchUserLocation()
        loadCategoryKeywords()
        loadSearchRankingConfig()
    }
    
    private fun loadCategoryKeywords() {
        scope.launch {
            commandBlock(showProgress = false) {
                com.example.mystybag.communication.common.CommonCommands.getCategoryKeywords()
                    .onResponse(
                        success = { response ->
                            launchOnMain {
                                val responseModel = response as? com.example.mystybag.sharedmodels.project.responseModels.nomenclatures.GetCategoryKeywordsResponseModel
                                val keywordsMap = responseModel?.keywords?.associate { 
                                    it.businessCategoryId to it.keywords 
                                } ?: emptyMap()
                                setCategoryKeywords(keywordsMap)
                            }
                        },
                        baseError = {
                            // Silently fail - use empty map if API fails
                            launchOnMain {
                                setCategoryKeywords(emptyMap())
                            }
                        }
                    )
            }
        }
    }
    
    private fun loadSearchRankingConfig() {
        scope.launch {
            commandBlock(showProgress = false) {
                com.example.mystybag.communication.common.CommonCommands.getSearchRankingConfig()
                    .onResponse(
                        success = { response ->
                            val model = response as? GetSearchRankingConfigResponseModel
                            if (model != null) {
                                SearchRankingRuntime.setFromServer(model.configs)
                            }
                        },
                        baseError = {
                            // Silently fail - use default configs if API fails
                        }
                    )
            }
        }
    }

    fun loadBagsData(bagsData: BagCategoryLists) {
        val userLat = uiState.value.userLatitude
        val userLon = uiState.value.userLongitude
        // Show only bags with at least 1 available (exclude 0 available from all lists)
        val availableOnly: (BagWithTextsAndMeta) -> Boolean =
            { (it.bagsCount - it.bagsReservationCount) > 0 }

        val allMapItems = bagsData.allBags.filter(availableOnly).map { it.toHomeTopPickUiModel(userLat, userLon) }
        val allBagsList = allMapItems

        val allBakery       = allBagsList.filter { it.businessCategoryId == CATEGORY_ID_BAKERY }
        val allConfectionery = allBagsList.filter { it.businessCategoryId == CATEGORY_ID_CONFECTIONERY }
        val allFoodForHome  = allBagsList.filter { it.businessCategoryId == CATEGORY_ID_FOOD_FOR_HOME }
        val allFishMarket   = allBagsList.filter { it.businessCategoryId == CATEGORY_ID_FISH_MARKET }

        // Create categoryIdByLocationId from available bags only (same as displayed lists)
        val categoryIdByLocationId = bagsData.allBags
            .filter(availableOnly)
            .filter { it.merchantLocationId != null && it.businessCategoryId != null }
            .distinctBy { it.merchantLocationId }
            .associate { it.merchantLocationId!! to it.businessCategoryId!! }

        updateState { state ->
            state.copy(
                allBakery           = allBakery,
                allConfectionery    = allConfectionery,
                allFoodForHome      = allFoodForHome,
                allFishMarket       = allFishMarket,
                allMapItems         = allMapItems,
                allBagsList         = allBagsList,
                categoryIdByLocationId = categoryIdByLocationId,
                isLoading           = false
            )
        }

        applyFilters()

        // If user location is not available, try to update with city location after bags are loaded
        if (uiState.value.userLatitude == null || uiState.value.userLongitude == null) {
            updateCityLocationIfNeeded()
        }
    }

    private fun getCategoryIdByLocationIdMap(): Map<Long, Long> {
        return uiState.value.categoryIdByLocationId
    }

    private fun fetchUserLocation() {
        scope.launch {
            // Check if we already have permission
            if (PermissionHelper.hasPermission(Permission.Location)) {
                // We have permission, try to get location
                tryGetUserLocation()
            } else {
                // Request permission
                val permissionGranted = PermissionHelper.requestPermission(Permission.Location)
                if (permissionGranted) {
                    // Permission was granted, wait a bit for the system to process it
                    delay(300)
                    // Double-check that we have permission now
                    if (PermissionHelper.hasPermission(Permission.Location)) {
                        // Now try to get location
                        tryGetUserLocation()
                    }
                    // If no permission, don't set location here - will be set after bags are loaded
                }
                // If permission denied, don't set location here - will be set after bags are loaded
            }
        }
    }
    
    private suspend fun tryGetUserLocation() {
        val userLocation = getCurrentUserLocation()
        if (userLocation != null) {
            val (latitude, longitude) = userLocation
            val previousLat = uiState.value.userLatitude
            val previousLon = uiState.value.userLongitude
            
            // Update state with user's current location
            updateState { state ->
                state.copy(
                    userLatitude = latitude,
                    userLongitude = longitude
                )
            }
            
            // If we have bags loaded, always recalculate distances when user location becomes available
            // This ensures accurate distances even if city location was set first
            if (uiState.value.allMapItems.isNotEmpty()) {
                // Recalculate if this is the first time we got user location, or if location changed significantly
                val shouldRecalculate = previousLat == null && previousLon == null || 
                    (previousLat != null && previousLon != null && 
                     (kotlin.math.abs(previousLat - latitude) > 0.001 || kotlin.math.abs(previousLon - longitude) > 0.001))
                
                if (shouldRecalculate) {
                    recalculateDistances(latitude, longitude)
                }
            }
        }
        // If could not get user location, don't set fallback here - will be set after bags are loaded
    }
    
    private fun recalculateDistances(userLat: Double, userLon: Double) {
        val s = uiState.value
        val allBags = s.allBakery + s.allConfectionery + s.allFoodForHome +
            s.allFishMarket + s.allMapItems + s.allBagsList

        val updatedDistances = allBags.associate { bag ->
            bag.id to if (bag.locationLatitude != 0.0 && bag.locationLongitude != 0.0) {
                calculateDistanceMeters(
                    userLat, userLon,
                    bag.locationLatitude, bag.locationLongitude
                )
            } else {
                null
            }
        }

        fun updateBagDistance(bag: HomeTopPickUiModel): HomeTopPickUiModel {
            val newDistance = updatedDistances[bag.id]
            return if (newDistance != null) {
                bag.copy(distance = formatDistance(newDistance))
            } else {
                bag
            }
        }

        updateState { state ->
            state.copy(
                allBakery        = state.allBakery.map(::updateBagDistance),
                allConfectionery = state.allConfectionery.map(::updateBagDistance),
                allFoodForHome   = state.allFoodForHome.map(::updateBagDistance),
                allFishMarket    = state.allFishMarket.map(::updateBagDistance),
                allMapItems      = state.allMapItems.map(::updateBagDistance),
                allBagsList      = state.allBagsList.map(::updateBagDistance),
                bakery           = state.bakery.map(::updateBagDistance),
                confectionery    = state.confectionery.map(::updateBagDistance),
                foodForHome      = state.foodForHome.map(::updateBagDistance),
                fishMarket       = state.fishMarket.map(::updateBagDistance),
                mapItems         = state.mapItems.map(::updateBagDistance)
            )
        }
    }
    
    /**
     * Updates the map location with city location if user location is not available.
     * This should be called AFTER bags are loaded so we can find the city with most bags.
     */
    private fun updateCityLocationIfNeeded() {
        scope.launch {
            commandBlock(showProgress = false) {
                LoginCommands.sendGetCities()
                    .onResponse(
                        success = { response ->
                            launchOnMain {
                                val responseModel = response as? GetCitiesResponseModel
                                val cities = responseModel?.citiesList ?: emptyList()
                                if (cities.isNotEmpty()) {

                                    val userCity        = cities.find { it.id == GlobalCommonData.getCityId() }
                                    val selectedCity    = userCity ?: cities.first()
                                    
                                    // Only update if we still don't have user location
                                    if (uiState.value.userLatitude == null || uiState.value.userLongitude == null) {
                                        updateState { state ->
                                            state.copy(
                                                userLatitude = selectedCity.latitude,
                                                userLongitude = selectedCity.longitude
                                            )
                                        }
                                    }
                                }
                            }
                        },
                        baseError = {
                            // Silently fail - keep default location
                        }
                    )
            }
        }
    }

    private fun getEmbeddings(){
        commandBlock(showProgress = false, hideProgress = false) {
            getMerchantEmbeddings()
                .onResponse(
                    success = { response ->
                        // Запазва embeddings в базата данни
                        DatabaseProvider.getEmbeddingsDao()?.upsertEmbeddings(
                            items               = response.items//,
                            //lastModifiedIso     = response. // или друг timestamp ако имаш
                        )

                    },
                    error = { response ->

                    }
                )
           // testSearch()
        }
    }


    /** Parses filter price string (e.g. "2,00") to Double for local filtering. */
    private fun parseFilterPrice(s: String): Double? {
        if (s.isBlank()) return null
        return s.replace(',', '.').trim().toDoubleOrNull()
    }

    /** Returns true if the bag passes the applied local filter (price, rating, distance, location, collection time). */
    private fun HomeTopPickUiModel.passesLocalFilter(f: FilterResultsUIState, userLat: Double?, userLon: Double?): Boolean {
        // Merchant location (obekt): show only bags from selected location; null = no filter
        if (f.selectedLocationId != null) {
            if (merchantLocationId != f.selectedLocationId) return false
        }
        // Price range (discounted price). priceMax == 0 means Unlimited (no maximum).
        val priceMin = parseFilterPrice(f.priceMin)
        val priceMaxRaw = parseFilterPrice(f.priceMax)
        val priceMax = if (priceMaxRaw != null && priceMaxRaw == 0.0) null else priceMaxRaw
        priceWithDiscountNumeric?.let { p ->
            if (priceMin != null && p < priceMin) return false
            if (priceMax != null && p > priceMax) return false
        } ?: run { if (priceMin != null || priceMax != null) return false }
        // Merchant rating: 0=Any, 1=3.0+, 2=4.0+, 3=4.5+. Bags with 0 rating (not yet rated) always pass when Any.
        val minRating = when (f.selectedRatingIndex) { 0 -> 0.0; 1 -> 3.0; 2 -> 4.0; 3 -> 4.5; else -> 0.0 }
        if (minRating > 0 && rating > 0 && rating < minRating) return false
        // Distance from user (only when "use my location" is on)
        if (f.useMyLocation && userLat != null && userLon != null) {
            val meters = calculateDistanceMeters(userLat, userLon, locationLatitude, locationLongitude)
            if (meters / 1000f > f.distanceKm) return false
        }
        // Collection time: 0=Any, 1=Available now (no filter), 2=08-12, 3=12-17, 4=Evening
        val info = collectInfo.lowercase()
        when (f.selectedCollectionTimeIndex) {
            2 -> if (!info.contains("08") && !info.contains("09") && !info.contains("10") && !info.contains("11") && !info.contains("12")) return false
            3 -> if (!info.contains("12") && !info.contains("13") && !info.contains("14") && !info.contains("15") && !info.contains("16") && !info.contains("17")) return false
            4 -> if (!info.contains("18") && !info.contains("19") && !info.contains("20") && !info.contains("21") && !info.contains("22") && !info.contains("evening")) return false
            else -> { /* 0 = Any, 1 = Available now - no time filter */ }
        }
        return true
    }

    private fun applyFilters() {
        updateState { state ->
            val searchLocationIds = state.searchedMerchantLocationIds
            val selectedCategory = state.selectedCategory

            fun <T : HomeTopPickUiModel> List<T>.filterIds(): List<T> =
                if (searchLocationIds.isEmpty()) this else filter { it.merchantLocationId?.let { locId -> locId in searchLocationIds } ?: false }

            fun <T : HomeTopPickUiModel> List<T>.applyLocalFilter(): List<T> =
                if (state.appliedFilter == null) this
                else filter { it.passesLocalFilter(state.appliedFilter!!, state.userLatitude, state.userLongitude) }

            // Филтрираме по избраната категория: показваме само нея, останалите са празни.
            val bakery        = if (selectedCategory == BusinessCategory.ALL || selectedCategory == BusinessCategory.BAKERY)
                state.allBakery.filterIds().applyLocalFilter() else emptyList()
            val confectionery = if (selectedCategory == BusinessCategory.ALL || selectedCategory == BusinessCategory.CONFECTIONERY)
                state.allConfectionery.filterIds().applyLocalFilter() else emptyList()
            val foodForHome   = if (selectedCategory == BusinessCategory.ALL || selectedCategory == BusinessCategory.FOOD_FOR_HOME)
                state.allFoodForHome.filterIds().applyLocalFilter() else emptyList()
            val fishMarket    = if (selectedCategory == BusinessCategory.ALL || selectedCategory == BusinessCategory.FISH_MARKET)
                state.allFishMarket.filterIds().applyLocalFilter() else emptyList()

            val allFilteredBags = bakery + confectionery + foodForHome + fishMarket
            val gridItemsForGrid = when (selectedCategory) {
                BusinessCategory.ALL -> state.allBagsList.filterIds().applyLocalFilter()
                else -> allFilteredBags
            }

            // Extract unique merchant locations from filtered bags (one bag per location for map pin)
            val uniqueMerchantLocations = allFilteredBags
                .filter { it.merchantLocationId != null }
                .groupBy { it.merchantLocationId }
                .values
                .map { locationBags ->
                    locationBags.maxByOrNull { it.bagsAvailable }
                        ?: locationBags.maxByOrNull { it.rating }
                        ?: locationBags.first()
                }

            state.copy(
                bakery           = bakery,
                confectionery    = confectionery,
                foodForHome      = foodForHome,
                fishMarket       = fishMarket,
                gridItemsForGrid = gridItemsForGrid,
                mapItems         = uniqueMerchantLocations
            )
        }
    }

    fun onRefresh() {
        updateState { it.copy(refreshing = true) }
        refreshBags {
            launchOnMain {
                updateState { it.copy(refreshing = false) }
            }
        }
    }

    fun observeSearch() {
        scope.launch {
            searchFlow.collectLatest { query ->
                val q = query.trim()
                if (q.isEmpty()) {
                    // Изчистваме резултатите от търсенето и показваме всички торби
                    updateState { it.copy(searchedMerchantLocationIds = emptySet()) }
                    applyFilters()
                    return@collectLatest
                }
                
                // Изчакваме допълнително време, за да позволим на потребителя да завърши въвеждането
                // debounce на searchFlow е 350ms, тук добавяме още 500ms за по-гладко търсене
                delay(500)
                
                // Проверяваме дали query-то все още е същото (за да избегнем ненужни търсения)
                if (searchControls.searchText.trim() == q) {
                    performSearch(q)
                }
            }
        }
    }

    val merchantCategories: Map<Long, String> by lazy {
        mapOf(
            1L to sharedString(SR.strings.business_category_bakery),
            2L to sharedString(SR.strings.business_category_confectionery),
            3L to sharedString(SR.strings.business_category_food_for_home),
            4L to sharedString(SR.strings.business_category_fish_market)
        )
    }

    fun performSearch(query: String) {
        if (query.isEmpty()) {
            updateState { it.copy(searchedMerchantLocationIds = emptySet()) }
            applyFilters()
            return
        }

        scope.launch {
            fun applySearchIds(ids: Set<Long>) {
                // Important: empty set means "no filtering" in applyFilters().
                // Use a sentinel id to represent "search active but 0 matches".
                val idsForFiltering = if (ids.isEmpty()) setOf(Long.MIN_VALUE) else ids
                updateState { it.copy(searchedMerchantLocationIds = idsForFiltering) }
                applyFilters()
            }

            fun fallbackTextSearchIds(): Set<Long> {
                val stopWords = setOf(
                    "ми", "се", "да", "на", "за", "с", "в", "от", "до", "и", "или", "ама", "че",
                    "нещо", "някакво", "някакъв", "някаква", "искам", "ям", "яде", "моля"
                )

                val cleaned = normalizeQueryForSearch(query)
                val tokenSource = cleaned.ifBlank { query }
                fun tokenizeNoRegex(text: String, minLen: Int): List<String> {
                    val s = text.trim().lowercase()
                    val out = ArrayList<String>()
                    val sb = StringBuilder()

                    fun flush() {
                        if (sb.length >= minLen) {
                            val t = sb.toString()
                            if (t !in stopWords) out.add(t)
                        }
                        sb.setLength(0)
                    }

                    for (ch in s) {
                        if (ch.isLetterOrDigit()) sb.append(ch) else flush()
                    }
                    flush()
                    return out
                }

                val tokens = tokenizeNoRegex(tokenSource, minLen = 2)

                if (tokens.isEmpty()) return emptySet()

                // Pre-compute keyword stems per category (from server-provided keywords map).
                val keywordsMap = categoryKeywordsRaw.value
                fun stemsFromKeywords(raw: String, minLen: Int): Set<String> {
                    val s = raw.lowercase()
                    val out = HashSet<String>()
                    val sb = StringBuilder()

                    fun flush() {
                        if (sb.length >= minLen) out.add(sb.toString())
                        sb.setLength(0)
                    }

                    for (ch in s) {
                        if (ch.isLetterOrDigit()) sb.append(ch) else flush()
                    }
                    flush()
                    return out
                }

                val stemsByCategory: Map<Long, Set<String>> =
                    keywordsMap.mapValues { (_, raw) -> stemsFromKeywords(raw, minLen = 3) }

                fun commonPrefixLen(a: String, b: String): Int {
                    val n = minOf(a.length, b.length)
                    var i = 0
                    while (i < n && a[i] == b[i]) i++
                    return i
                }

                fun stemMatchesToken(token: String, stem: String, minPrefix: Int = 3): Boolean {
                    if (token.isEmpty() || stem.isEmpty()) return false
                    if (token.startsWith(stem) || stem.startsWith(token)) return true
                    return commonPrefixLen(token, stem) >= minPrefix
                }

                fun normalizeHaystack(text: String): String {
                    val s = text.lowercase()
                    val sb = StringBuilder(s.length)
                    var lastWasSpace = true
                    for (ch in s) {
                        when {
                            ch.isLetterOrDigit() -> {
                                sb.append(ch)
                                lastWasSpace = false
                            }
                            ch.isWhitespace() -> {
                                if (!lastWasSpace) {
                                    sb.append(' ')
                                    lastWasSpace = true
                                }
                            }
                            else -> {
                                if (!lastWasSpace) {
                                    sb.append(' ')
                                    lastWasSpace = true
                                }
                            }
                        }
                    }
                    return sb.toString().trim()
                }

                fun textMatches(haystack: String, token: String): Boolean {
                    if (haystack.contains(token)) return true
                    // prefix match for more forgiving search (e.g. "слад" -> "сладкарница")
                    val words = haystack.split(' ')
                    return words.any { w ->
                        w.startsWith(token) || token.startsWith(w)
                    }
                }

                // Score per locationId and return the best-matching locations.
                val bestScoreByLocation = HashMap<Long, Int>()

                for (item in uiState.value.allMapItems) {
                    val locId = item.merchantLocationId ?: continue

                    val haystack = buildString {
                        append(item.title)
                        append(' ')
                        append(item.subtitle)
                        append(' ')
                        item.bagTitle?.let { append(it) }
                        append(' ')
                        item.locationAddress?.let { append(it) }
                        append(' ')
                        item.cityName?.let { append(it) }
                        append(' ')
                        item.businessCategoryTitle?.let { append(it) }
                        append(' ')
                        item.products.forEach { append(it.name); append(' ') }
                    }.let(::normalizeHaystack)

                    var score = 0

                    // Text token hits
                    for (t in tokens) {
                        if (textMatches(haystack, t)) score += 3
                    }

                    // Category keyword hits (from server keywords)
                    val catId = item.businessCategoryId
                    if (catId != null) {
                        val stems = stemsByCategory[catId].orEmpty()
                        if (stems.isNotEmpty()) {
                            var hits = 0
                            for (t in tokens) {
                                if (stems.any { s -> stemMatchesToken(t, s) }) hits++
                            }
                            score += hits * 2
                        }
                    }

                    if (score <= 0) continue
                    val prev = bestScoreByLocation[locId]
                    if (prev == null || score > prev) bestScoreByLocation[locId] = score
                }

                return bestScoreByLocation.entries
                    .sortedByDescending { it.value }
                    .take(50)
                    .map { it.key }
                    .toSet()
            }

            try {
                // 1) Взема embeddings от базата данни
                val embeddings = DatabaseProvider.getEmbeddingsDao()?.getAllEmbeddings() ?: emptyList()

                if (embeddings.isEmpty()) {
                    applySearchIds(fallbackTextSearchIds())
                    return@launch
                }

                // 2) Map: merchantLocationId -> businessCategoryId from bagsData.allBags
                val categoryIdByLocationId = getCategoryIdByLocationIdMap()

                // 3) Взема embedder
                val embedder = try {
                    E5Runtime.get()
                } catch (e: Throwable) {
                    e.printStackTrace()
                    throw e
                }

                // 4) Локално търсене
                val results = withContext(Dispatchers.Default) {
                    searchLocalTwoStage(
                        embedder = embedder,
                        queryText = query,
                        embeddings = embeddings,
                        categoryIdByLocationId = categoryIdByLocationId, // ✅ NEW
                    )
                }

                results.take(5).forEachIndexed { idx, hit ->

                    val businessName = merchantCategories.get(categoryIdByLocationId.get(hit.merchantLocationId))

                    val formattedScore = com.example.mystybag.core.expected.format("%.4f", hit.score)
                    println("  #${idx + 1} locId=${hit.merchantLocationId} businessCategory=$businessName score=$formattedScore")
                }

                // 5) merchantLocationIds от резултатите
                val merchantLocationIds = results.map { it.merchantLocationId }.toSet()

                applySearchIds(merchantLocationIds)
            } catch (t: Throwable) {
                // Very important: E5 iOS implementation is currently incomplete and may throw
                // NotImplementedError (which is NOT an Exception). Fallback prevents crashes.
                t.printStackTrace()
                applySearchIds(fallbackTextSearchIds())
            }
        }

    }

    /** List или Map таб е избран */
    fun onViewModeSelected(mode: HomeViewMode) {
        updateState { it.copy(viewMode = mode) }
    }
    
    fun onCategorySelected(category: BusinessCategory) {
        updateState { it.copy(selectedCategory = category) }
        applyFilters()
    }

    override fun scrollToTop() {
        scrollToTopChannel.trySend(Unit)
    }

    fun onFavouriteClick(item: HomeTopPickUiModel) {
        if (item.isFavorite) {
            removeFavorite(item)
        } else {
            addFavorite(item)
        }
    }

    private fun addFavorite(item: HomeTopPickUiModel) {
        val merchantLocationId = item.merchantLocationId
        if (merchantLocationId == null) {
            // TODO: Show error - merchantLocationId is required
            return
        }
        commandBlock(showProgress = false, hideProgress = false) {
            addFavoriteCommand(
                AddFavoriteRequestModel(
                    userId = Preferences.getLong(PREFERENCES_USER_ID, 0L),
                    merchantLocationId = merchantLocationId
                )
            ).onResponse(
                success = {
                    toggleFavouriteInState(item)
                    // Refresh bags to update favorites page
                    refreshBags()
                },
                error = {
                    // TODO: error UI
                }
            )
        }
    }

    /** Called from Favorites page when user removes an item from favorites. */
    fun removeFavoriteItem(item: HomeTopPickUiModel) {
        removeFavorite(item)
    }

    private fun removeFavorite(item: HomeTopPickUiModel) {
        val merchantLocationId = item.merchantLocationId
        if (merchantLocationId == null) {
            // TODO: Show error - merchantLocationId is required
            return
        }
        commandBlock(showProgress = false, hideProgress = false) {
            removeFavoriteCommand(
                RemoveFavoriteRequestModel(
                    userId = Preferences.getLong(PREFERENCES_USER_ID, 0L),
                    merchantLocationId = merchantLocationId
                )
            ).onResponse(
                success = {
                    toggleFavouriteInState(item)
                    // Refresh bags to update favorites page
                    refreshBags()
                },
                error = {
                    // TODO: error UI
                }
            )
        }
    }


    fun onTopPickClick(item: HomeTopPickUiModel) {
        if (isNavigatingToBag) return
        isNavigatingToBag = true
        prepareHomeForBagNavigation()
        navigate(NavigatorBagPage(bagItem = item))
    }
    
    fun onLocationClick(location: HomeTopPickUiModel) {
        // Check if there are other merchant locations at the same coordinates (same address)
        val threshold = 0.0001 // Approximately 10-11 meters
        val nearbyLocations = uiState.value.mapItems.filter { other ->
            other.merchantLocationId != location.merchantLocationId &&
            kotlin.math.abs(other.locationLatitude - location.locationLatitude) < threshold &&
            kotlin.math.abs(other.locationLongitude - location.locationLongitude) < threshold
        }
        // Single pin: list of 1; multiple at same address: list of all – show in horizontal bottom sheet list
        val listToShow = if (nearbyLocations.isNotEmpty()) listOf(location) + nearbyLocations else listOf(location)
        updateState { it.copy(selectedLocationsForSheet = listToShow, locationsToSelect = emptyList()) }
    }
    
    fun onLocationSelectedFromList(location: HomeTopPickUiModel) {
        updateState { 
            it.copy(
                selectedLocationsForSheet = listOf(location),
                locationsToSelect = emptyList()
            )
        }
    }
    
    fun onLocationsAtSameAddress(locations: List<HomeTopPickUiModel>) {
        // Cluster tap: fill horizontal list with all locations in the cluster
        updateState { it.copy(selectedLocationsForSheet = locations, locationsToSelect = emptyList()) }
    }
    
    fun onDismissLocationSelection() {
        updateState { it.copy(locationsToSelect = emptyList()) }
    }
    
    fun onDismissLocationBottomSheet() {
        updateState { it.copy(selectedLocationsForSheet = emptyList()) }
    }

    fun onFilterClick() {
        parentCallbacks?.parentOpenBottomSheet(BSNavigationFilterResults)
    }

    /** Applies the selected filter from the Filter bottom sheet locally to the bags list. */
    fun applyLocalFilters(filterState: FilterResultsUIState) {
        updateState {
            it.copy(
                appliedFilter = filterState,
                selectedCategory = BusinessCategory.ALL
            )
        }
        applyFilters()
    }

    /** Removes one filter dimension (e.g. distance or rating). If all become default, clears applied filter. */
    fun clearFilterChip(type: FilterResultsUIState.ActiveFilterType) {
        val current = uiState.value.appliedFilter ?: return
        val next = when (type) {
            FilterResultsUIState.ActiveFilterType.DISTANCE -> current.copy(distanceKm = FilterResultsUIState.default.distanceKm)
            FilterResultsUIState.ActiveFilterType.RATING -> current.copy(selectedRatingIndex = 0)
            FilterResultsUIState.ActiveFilterType.PRICE -> current.copy(priceMin = FilterResultsUIState.default.priceMin, priceMax = FilterResultsUIState.default.priceMax)
            FilterResultsUIState.ActiveFilterType.LOCATION -> current.copy(selectedLocationId = null)
            FilterResultsUIState.ActiveFilterType.PUBLISHED_DATE -> current.copy(selectedPublishedDateIndex = FilterResultsUIState.default.selectedPublishedDateIndex)
            FilterResultsUIState.ActiveFilterType.COLLECTION_TIME -> current.copy(selectedCollectionTimeIndex = 0)
        }
        val newFilter = if (next.distanceKm == FilterResultsUIState.default.distanceKm
            && next.selectedRatingIndex == FilterResultsUIState.default.selectedRatingIndex
            && next.priceMin == FilterResultsUIState.default.priceMin
            && next.priceMax == FilterResultsUIState.default.priceMax
            && next.selectedLocationId == FilterResultsUIState.default.selectedLocationId
            && next.selectedPublishedDateIndex == FilterResultsUIState.default.selectedPublishedDateIndex
            && next.selectedCollectionTimeIndex == FilterResultsUIState.default.selectedCollectionTimeIndex
        ) null else next
        updateState { it.copy(appliedFilter = newFilter) }
        applyFilters()
    }

    /** Returns the currently applied filter (for pre-filling the filter sheet when reopened). */
    fun getAppliedFilter(): FilterResultsUIState? = uiState.value.appliedFilter

    /**
     * Всички торби от текущия клиентски каталог (обединение по категории + allBags), без дубликати по id.
     * Използва се напр. за „Виж торбата“ от детайли на резервация само ако офертата още е в списъка ни.
     */
    fun getAllCatalogBagsFlattened(): List<HomeTopPickUiModel> {
        val s = uiState.value
        val merged = s.allBakery + s.allConfectionery + s.allFoodForHome +
            s.allFishMarket + s.allMapItems + s.allBagsList
        return merged.distinctBy { it.id }
    }

    /** Distinct merchant locations (id to display name) from current results, for the location filter. */
    fun getAvailableLocationsForFilter(): List<Pair<Long, String>> {
        val s = uiState.value
        val allBags = s.allBakery + s.allConfectionery + s.allFoodForHome +
            s.allFishMarket + s.allMapItems + s.allBagsList
        return allBags
            .mapNotNull { it.merchantLocationId?.let { id -> id to (it.locationTitle?.takeIf { t -> t.isNotBlank() } ?: it.title) } }
            .distinctBy { it.first }
            .sortedBy { it.second }
    }
    
    /**
     * Called when user taps the location dialog (pin on map).
     * Opens bag details for the tapped bag item.
     */
    fun onLocationDialogTap(bagItem: HomeTopPickUiModel?) {
        if (isNavigatingToBag) return
        isNavigatingToBag = true
        prepareHomeForBagNavigation()
        navigate(NavigatorBagPage(bagItem = bagItem))
    }

    fun onSeeAllCategoryClick(
        businessCategoryId: Long?,
        categoryTitle: String,
        bags: List<com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel>
    ) {
        navigate(
            com.example.mystybag.appCore.logic.NavigatorCategoryBagsList(
                businessCategoryId = businessCategoryId,
                categoryTitle = categoryTitle,
                bags = bags
            )
        )
    }
    
    /**
     * Total active bags and single price pair for the location card: priceNormal (strikethrough), priceWithDiscount (green).
     * Uses the first available bag at the location – няма price range, само една двойка priceNormal / priceWithDiscount.
     */
    fun getLocationActiveBagsInfo(locationId: Long?): Pair<Int, Pair<String?, String?>> {
        if (locationId == null) return Pair(0, Pair(null, null))
        
        val locationBags = uiState.value.allMapItems
            .filter { it.merchantLocationId == locationId && it.bagsAvailable > 0 }
        
        val totalBags = locationBags.size
        val first = locationBags.firstOrNull() ?: return Pair(totalBags, Pair(null, null))
        
        val priceNormalStr = first.oldPrice.takeIf { it.isNotBlank() }
        val priceWithDiscountStr = first.newPrice.takeIf { it.isNotBlank() }
        return Pair(totalBags, Pair(priceNormalStr, priceWithDiscountStr))
    }
    
    /**
     * Parses price string to Double
     * Handles formats like "12,00 €", "4,00 €", "12.50 EUR", etc.
     */
    private fun parsePrice(priceStr: String): Double? {
        if (priceStr.isEmpty()) return null
        
        return try {
            // Remove currency symbols and whitespace
            val cleaned = priceStr
                .replace("€", "")
                .replace("EUR", "")
                .replace(" ", "")
                .trim()
            
            // Replace comma with dot for decimal separator
            val normalized = cleaned.replace(",", ".")
            
            normalized.toDoubleOrNull()
        } catch (e: Exception) {
            null
        }
    }

    private fun updateHeader(isPrivate: Boolean? = null) {
        val private = isPrivate ?: getBoolean(PREFERENCES_IS_PRIVATE_MODE, false)

        val newHeader = HeaderRowVisualModel(
            onBackClick         = ::onBackButtonClicked,
            onProfileImageClick = ::onPersonalDetailsClicked,
            profileImage        = ImageDescription(
                link = getString(PREFERENCES_PHOTO_GUID, "").let { raw -> if (raw.startsWith("http")) raw else raw.ifNotEmpty { it.addDownloadLink() } },
                icon = IconDescription(
                    resource  = SRC.images.avatar_fill_icon,
                    imageSize = p18
                )
            ),
            buttons             = mutableListOf<ButtonImageVisualModel>().apply {
                if (getOS() == ANDROID && isNFCChipPresent()) {
                    add(
                        ButtonImageVisualModel(
                            buttonImage = if (private)
                                SRC.images.eye_off_outline_icon
                            else
                                SRC.images.eye_on_outline_icon,
                            isSelected  = private
                        )
                    )
                }
            }.toImmutableList()
        )

        updateState { state ->
            state.copy(header = newHeader)
        }
    }

    private fun toggleFavouriteInState(item: HomeTopPickUiModel) {
        updateState { state ->
            fun toggle(list: List<HomeTopPickUiModel>) =
                list.map { model ->
                    if (model.id == item.id) {
                        model.copy(isFavorite = !model.isFavorite)
                    } else model
                }

            val bakery        = toggle(state.bakery)
            val confectionery = toggle(state.confectionery)
            val foodForHome   = toggle(state.foodForHome)
            val fishMarket    = toggle(state.fishMarket)
            val allBagsList   = toggle(state.allBagsList)
            val filteredAllBags = if (state.searchedMerchantLocationIds.isEmpty()) allBagsList
                else allBagsList.filter { it.merchantLocationId?.let { id -> id in state.searchedMerchantLocationIds } ?: false }
            val gridItemsForGrid = when (state.selectedCategory) {
                BusinessCategory.ALL -> filteredAllBags
                else -> bakery + confectionery + foodForHome + fishMarket
            }
            state.copy(
                bakery = bakery,
                confectionery = confectionery,
                foodForHome = foodForHome,
                fishMarket = fishMarket,
                allBagsList = allBagsList,
                gridItemsForGrid = gridItemsForGrid
            )
        }
    }

    private fun onPersonalDetailsClicked() {
        navigateTo(FeatureManagers.PersonalDetails)
    }

    fun refreshBags(onComplete: (() -> Unit)? = null) {
        (parentCallbacks as? HomePageCallbacks)?.refreshBags(onComplete)
    }

    private fun prepareHomeForBagNavigation() {
        hideWebHomeMapOverlayNow()
        updateState { state ->
            state.copy(
                selectedLocationsForSheet = emptyList(),
                locationsToSelect = emptyList()
            )
        }
    }
}